export const election = {
  /** Election day, 8:00 a.m. Colombia time */
  startsAt: '2026-12-03T08:00:00-05:00',
  dateLabel: 'Jueves, 3 de diciembre de 2026',
  title: 'Elecciones Junta Directiva',
  period: '2027 – 2030',
  listNumber: 1,
  censusUrl: 'https://www.ccc.org.co/landing/elecciones-de-junta-directiva/#table',
  calendarUrl:
    'https://calendar.google.com/calendar/render?action=TEMPLATE&text=Elecciones%20Junta%20Directiva%20C%C3%A1mara%20de%20Comercio%20de%20Cali%20%E2%80%94%20Vota%20Lista%20No.%201&dates=20261203T130000Z/20261203T220000Z&details=Grupo%20Consultor%20Colombiano%20%E2%80%94%20Vota%20Lista%20No.%201&location=Cali%2C%20Colombia',
  posterImage:
    'https://cdn.magicpatterns.com/uploads/5rHzuR55iawbKyGeDwqMZU/Lista_elecciones_CAmara_-_Grupo_Consultor_Colombiano.jpg',
  closingImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/1bfbdca0-bd31-4831-9be7-3ae952ac5421.jpg',
  censusImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/cae921d1-56fe-4a11-95a7-c85844833336.jpg',
}

export const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'La lista', href: '#lista' },
  { label: 'Historia', href: '#historia' },
  { label: 'Ruta 2027–2030', href: '#ruta' },
  { label: 'Referencias', href: '#referencias' },
  { label: 'Miembros', href: '#miembros' },
]
